// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JaUK","clinicsSelect":"styles_clinicsSelect__3o0WD"};